export const PLATFORM_NOTICE_DISMISSED_KEY = "platformNoticeDismissed";
export const PLATFORM_NOTICE_FETCHED_KEY = "platformNoticeFetched";

export const resetPlatformNoticeSession = () => {
  sessionStorage.removeItem(PLATFORM_NOTICE_DISMISSED_KEY);
  sessionStorage.removeItem(PLATFORM_NOTICE_FETCHED_KEY);
};

export const clearPlatformNoticeSession = resetPlatformNoticeSession;
